import type {} from '@angular/localize/init';
import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { appRoutesI18nCache } from '../i18n-cache';

export function liveCasinoRouteI18n(config?: TranslationConfig): string {
  if (config?.translateForLang && globalThis.$localizeForLang) {
    return globalThis.$localizeForLang`:url-segment@@live-casino-url-segment:live-casino`;
  }
  return (appRoutesI18nCache['live-casino'] ??= $localize`:url-segment@@live-casino-url-segment:live-casino`);
}
